import { render } from "./CommunicationChatContainer.vue?vue&type=template&id=7aa557f4&scoped=true&ts=true"
import script from "./CommunicationChatContainer.vue?vue&type=script&lang=ts"
export * from "./CommunicationChatContainer.vue?vue&type=script&lang=ts"

import "./CommunicationChatContainer.vue?vue&type=style&index=0&id=7aa557f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa557f4"]])

export default __exports__